<template>
    <header class="proc-header-compact">
        <div class="proc-header-main">
            <div class="proc-header-info">
                <h2>{{ processo?.nmprocesso || 'Processo' }}</h2>

                <div class="proc-header-line">
                    <span>Processo #{{ processo?.id || '-' }}</span>
                    <span v-if="processo?.protocolo">Protocolo: {{ processo.protocolo }}</span>
                    <span>{{ processo?.nmsim || '-' }}</span>
                    <span>{{ processo?.nmestabelecimento || '-' }}</span>
                    <span>{{ processo?.cpfcnpj || '-' }}</span>
                </div>

                <div class="proc-header-line">
                    <strong>Etapa:</strong>
                    <span>{{ etapa?.ordem || '-' }} - {{ etapa?.nmetapa || '-' }}</span>

                    <strong>Status:</strong>
                    <span>{{ etapa?.nmstatus || processo?.nmstatus_etapa || '-' }}</span>

                    <strong>Perfil:</strong>
                    <span>{{ perfil?.nmperfil || 'Sem perfil na etapa' }}</span>
                </div>
            </div>

            <div class="proc-resumo-box">
                <div>
                    <strong>{{ resumo.qtd_anexo_ok }}/{{ resumo.qtd_anexo_total }}</strong>
                    <span>Anexos</span>
                </div>
                
                <div>
                    <strong>{{ resumo.qtd_doc_ok }}/{{ resumo.qtd_doc_total }}</strong>
                    <span>Formulários</span>
                </div>
            </div>
        </div>
    </header>

    <!-- JUSTIFICATIVA DE RETORNO -->
    <section
        v-if="
            etapa?.retornada_ck === 'S' &&
            etapa?.retornada_justificativa?.trim()
        "
        class="proc-retorno-info"
    >
        <div class="proc-retorno-icon">
            <span>↩</span>
        </div>

        <div class="proc-retorno-conteudo">
            <div class="proc-retorno-titulo">
                Etapa retornada para correção
            </div>

            <div class="proc-retorno-label">
                Justificativa do retorno
            </div>

            <div class="proc-retorno-texto">
                {{ etapa.retornada_justificativa }}
            </div>
        </div>
    </section>
</template>

<script setup>
defineProps({
    processo: { type: Object, default: null },
    etapa: { type: Object, default: null },
    perfil: { type: Object, default: null },
    etapaAnterior: { type: Object, default: null },
    etapaProxima: { type: Object, default: null },
    resumo: {
        type: Object,
        default: () => ({
            qtd_doc_total: 0,
            qtd_doc_ok: 0,
            qtd_anexo_total: 0,
            qtd_anexo_ok: 0,
        }),
    },
});
</script>

<style scoped>
/* =========================================================
   JUSTIFICATIVA DE RETORNO
   ========================================================= */
.proc-retorno-info {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    padding: 12px 14px;

    color: #5f3b00;
    background: #fff8e8;

    border: 1px solid #e8c36a;
    border-left: 4px solid #c88900;
    border-radius: 7px;
}

.proc-retorno-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    flex: 0 0 30px;
    width: 30px;
    height: 30px;

    font-size: 19px;
    font-weight: 700;

    color: #8a5900;
    background: #ffe7ad;
    border-radius: 50%;
}

.proc-retorno-conteudo {
    flex: 1;
    min-width: 0;
}

.proc-retorno-titulo {
    margin-bottom: 5px;

    font-size: 14px;
    font-weight: 700;
    color: #754b00;
}

.proc-retorno-label {
    margin-bottom: 3px;

    font-size: 11px;
    font-weight: 600;
    color: #9a6b16;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.proc-retorno-texto {
    font-size: 13px;
    line-height: 1.45;
    color: #4f3b17;

    /* Preserva as quebras de linha recebidas no JSON */
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}
</style>